import { useAsyncData } from "@faedev/editor-utils";
import { useCookies } from "react-cookie";
import constants from "src/constants";
import getCookieByName from "src/functions/getCookieByName";
import validateAuthToken from "src/functions/validateAuthToken";

function useLoggedInUser() {
  var [cookies, setCookie] = useCookies(null);
  const isAuthorized = getCookieByName(`auth-token`);

  var response = useAsyncData(
    () =>
      constants.Show.accountSign && typeof isAuthorized === "string"
        ? fetch(`${constants.Paths.apiUrl}/users/me`, {
            headers: validateAuthToken(getCookieByName(`auth-token`)),
          }).then((res) => {
            if (res.ok) {
              return res.json();
            } else {
              throw new Error("API Error");
            }
          })
        : Promise.resolve(false),
    [cookies[`auth-token`]]
  );
  return response;
}

export default useLoggedInUser;
